<template>
 <v-row>
   <v-dialog v-model="showDialog" scrollable max-width="400px" max-height="90%">
     <v-card>
       <v-card-title style="padding: 5px 0 0 5px;">
         <v-col cols="12">
					<span style="font-size: 20px;">
						{{ $t('wkt.admin.complaintconfig.confirm-enable-module-dialog.title') }}
					</span>
           <!-- <v-btn icon style="top: -20px; left: 10px; float: right;">
             <v-icon @click="showDialog=false">close</v-icon>
           </v-btn> -->
				</v-col>          
       </v-card-title>
			<v-divider></v-divider>
       <v-card-text style="padding-bottom: 0;">
				<v-container class="pa-0">
					<v-form ref="form">								
						<v-row class="ma-0">
							<v-col cols="12">
								<span v-html="$t('wkt.admin.complaintconfig.confirm-enable-module-dialog.text')"></span>
							</v-col>	
							<v-col cols="12">
								<v-text-field
									ref="cif"
									v-model="text"
									autocomplete="none"
									:error-messages="errorMessages"
									max="200" />
							</v-col>													
						</v-row>
					</v-form>
				</v-container>
       </v-card-text>
       <v-divider></v-divider>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.confirm').toUpperCase() }}</v-btn>
         <v-btn text @click="cancel()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

 </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js';

export default {
	name: 'ConfirmEnableComplaintModuleDialog',
	mixins: [BaseModule],
	components: {
	},
	data () {
		return {
			showDialog: false,
			loading: false,
			text: null,
			msgCbOk: null,
			msgCbCancel: null,
			errorMessages: '',
		}
	},
	methods: {
		open: function(msgCbOk, msgCbCancel) {
			if (this.$refs.form) {
				this.$refs.form.resetValidation();
			}

			this.text = null;
			this.msgCbOk = msgCbOk;
			this.msgCbCancel = msgCbCancel;
			this.errorMessages = '';

			this.showDialog = true;
		},
		ok: function() {
			this.errorMessages = '';

			if (!this.text) {
				this.errorMessages = this.$t('wkt.admin.common.validation-utils.required_field');
				return;
			}

			if (this.text !== 'ACEPTAR') {
				this.errorMessages = this.$t('wkt.admin.common.validation-utils.invalid_field');
				return;
			}

			this.showDialog = false;
			
			if (this.msgCbOk) {
				this.msgCbOk();
			}
		},
		cancel() {
			this.showDialog = false;
			
			if (this.msgCbCancel) {
				this.msgCbCancel();
			}
		}
	},
}
</script>